/* This file was generated automatically. Do not edit manually. */

export enum QueueItemState {
    Scheduled = 'Scheduled',
    Success = 'Success',
    Failed = 'Failed',
    Waiting = 'Waiting',
    Processing = 'Processing',
    Canceled = 'Canceled',
    Warning = 'Warning',
    TimedOut = 'TimedOut',
}
